import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";
const ModalContent = styled("div")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "464px",
  borderRadius: "8px",
  background: "#fff",
  padding: "32px 28px",
  "@media (max-width: 600px)": {
    width: "312px",
    padding: "24px",
    borderRadius: "28px",
    fontFamily: "Inter, sans-serif",
  },
});

const ModalClose = styled("a")({
  width: "24px",
  height: "24px",
  position: "absolute",
  top: "20px",
  right: "20px",
  cursor: "pointer",
  color: "#aaa",
  "@media (max-width: 600px)": {
    display: "none",
  },
});

interface IProps {
  open: boolean;
  handCancel?: VoidFunction;
  handConfirm?: VoidFunction;
}
export default function TurnOffWebsiteModal({
  open,
  handCancel,
  handConfirm,
}: IProps) {
  return (
    <Modal open={open} onClose={handCancel}>
      <ModalContent>
        <ModalClose>
          <CloseIcon onClick={handCancel}></CloseIcon>
        </ModalClose>
        <Typography
          sx={{
            fontSize: "20px",
            lineHeight: "32px",
            fontWeight: "600",
            color: "#111315",
          }}
          variant="h6"
        >
          Thông báo
        </Typography>
        <Typography
          sx={{
            marginTop: "16px",
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "400",
            color: "#919AA4",
            fontFamily: "Inter, sans-serif",
          }}
        >
          Bạn có muốn ngừng xuất bản website ngay bây giờ?
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            marginTop: "28px",
          }}
        >
          <Button
            variant="contained"
            sx={(theme) => ({
              padding: "10px 9px",
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              fontFamily: "Inter,sans-serif",
              color: "#fff",
              borderRadius: "12px",
              background: "#DD3730",
              boxShadow: "none",
              ":hover": {
                background: "#DD3730",
                color: "#fff",
              },
            })}
            onClick={handConfirm}
          >
            Ngừng xuất bản
          </Button>
          <Button
            variant="contained"
            sx={(theme) => ({
              boxShadow: "none",
              padding: "10px 50px",
              border: "1px solid #E5E7E9",
              borderRadius: "12px",
              background: "#fff",
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              fontFamily: "Inter,sans-serif",
              marginLeft: "8px",
              color: "#0070F4",
            })}
            onClick={handCancel}
          >
            Huỷ
          </Button>
        </Box>
      </ModalContent>
    </Modal>
  );
}
